
const config = require ('../../../configs/configuration.js')
const constants = config.configuration.data;
var indicators;

import { _, getParameterValue } from './lang';

function setupLocalisation() {
    'use strict';

    String.locale = window.defaultLanguage;
    String.toLocaleString(window.availableLanguages);
    let lang = getParameterValue('lang');
    if (lang !== '' && lang !== "") {
        for (var value in window.availableLanguages) {
            if (value === lang) {
                String.locale = lang;
            }
        }
    }

}

function localise (category = 0) {
    indicators = window.indicators; 
    document.title = _("document.title");
    
    const indicator = indicators[category];  
    const chapter = indicator.code.replace(/\./g, '_');

    const mainTitleString = `indicator${chapter}.title`;
    const mainTitle = document.getElementById('chart_title');
    mainTitle.innerHTML = _(mainTitleString);
    document.title = _(mainTitleString).split(",")[0];

    const subTitleString = `indicator${chapter}.subTitle`;
    const subTitle = document.getElementById('chart_subtitle');
    subTitle.innerHTML = _(subTitleString);

    const footnoteString = `indicator${chapter}.footnote`;
    const footnote = document.getElementById('footnote');
    footnote.innerHTML = _(footnoteString);

    //bookmark 
    const link = _(indicator.bookmarkText);
    let areaLink = document.createElement('a');
    var linkText = typeof indicator.sourceText == "function" ?  indicator.sourceText() : _(indicator.sourceText);

    let areaLinkText = document.createTextNode(linkText);
    let areaLinkLink = 'bookmarklink';

    areaLink.setAttribute('target', '_blank');
    areaLink.setAttribute('href', indicator.bookmark);
    areaLink.setAttribute('class', 'infolink');
    areaLink.appendChild(areaLinkText);
        

    let linkContainer = document.getElementById('bookmark-link');
    linkContainer.innerHTML = link;
    linkContainer.appendChild(areaLink);


}


function localiseInterface(category) {
    'use strict';    
    try {
        localise(category);
    } catch (exp) {
        console.log(exp);
    }

}

export {
    setupLocalisation,
    localiseInterface
};